/**
 * @Description:  工具文件入库
 * @Author:       wangyaqiang
 * @Date: 2022-03-22 12:58:05
 * @LastEditors:  wangyaqiang
 * @LastEditTime: 2022-03-22 20:47:36
 */
// 全局组件
const requireFunc = require.context('./', true, /.vue$/);
const requireAll = context => context.keys().map(path => context(path).default);
const globals = requireAll(requireFunc);
export default {
    install(Vue) {
        // 注册全局业务组件
        for (const component of Object.values(globals)) {
            Vue.component(component.name, component);
        }
    },
};
